// import { RequireAutorization } from './routerAuth'

export default {
  name: 'Services',
  path: '/servicos',
  component: () => import(/* webpackChunkName: "Services" */ '@apps/services/Index.vue'),
  meta: { title: 'Serviços' },
  children: [
    {
      path: 'criar',
      name: 'ServiceNew',
      component: () => import(/* webpackChunkName: "Services" */'@apps/services/New.vue'),
      meta: { title: 'Criar Serviço' },
    },
    {
      path: ':serviceId/editar',
      name: 'ServiceEdit',
      component: () => import(/* webpackChunkName: "Services" */'@apps/services/Edit.vue'),
      meta: { title: 'Editar Serviço' },
    },
    {
      path: ':serviceId',
      name: 'ServiceShow',
      component: () => import(/* webpackChunkName: "Services" */'@apps/services/Show.vue'),
      meta: { title: 'Exibir Serviço' },
    },
  ],
  // beforeEnter: RequireAutorization
}
